import React from 'react';
import './Services.css';
import bgimage1 from "../Assets/service1.webp"
import bgimage2 from "../Assets/service2.webp"
import bgimage3 from "../Assets/service3.webp"
import bgimage4 from "../Assets/service4.webp"
import bgimage5 from "../Assets/service5.webp"
import bgimage6 from "../Assets/service6.webp"
//----------------- icons services ------------
import icon1 from "../Assets/icon1.png"
import icon2 from "../Assets/icon2.png"
import icon3 from "../Assets/icon3.png"
import icon4 from "../Assets/icon4.png"
import icon5 from "../Assets/icon5.png"
import icon6 from "../Assets/icon6.png"
import { useNavigate } from 'react-router-dom';


const Services = () => {
  const navigate = useNavigate()
const servicesData = [
  {
    id: 1,
    icon: icon1,
    backgroundImage: bgimage1, 
    title: 'Integrated Media & Brand Management Services',
    description: 'Strategic communication and brand positioning services to enhance project visibility, stakeholder engagement, and community awareness through comprehensive media management.'
  },
  {
    id: 2,
    icon: icon2, 
    backgroundImage: bgimage2,
    title: 'Land Acquisition, Alienation, Rehabilitation & Resettlement Services for Large Projects',
    description: 'End-to-end land acquisition solutions ensuring compliance with regulatory frameworks, transparent processes, and dignified rehabilitation of affected communities.'
  },
  {
    id: 3,
    icon: icon3, 
    backgroundImage: bgimage3, 
    title: 'Due Diligence, Title Search, Field Survey, Land Legal Matter & Consent of Land Owners',
    description: 'Comprehensive legal and technical verification services including exhaustive title searches, field surveys, and securing legitimate landowner consent for project implementation.'
  },
  {
    id: 4,
    icon: icon4, 
    backgroundImage: bgimage4, 
    title: 'Land Regularisation, Land Dispute Resolutions',
    description: 'Expert mediation and legal resolution services to address land disputes, regularize holdings, and ensure clear titles for seamless project execution.'
  },
  {
    id: 5,
    icon: icon5, 
    backgroundImage: bgimage5, 
    title: 'PH for SIA Studies, Gram Sabhas & Other PHs',
    description: 'Facilitation of Public Hearings for Social Impact Assessment studies, Gram Sabha consultations, and stakeholder engagement ensuring participatory decision-making.'
  },
  {
    id: 6,
    icon: icon6,
    backgroundImage: bgimage6, 
    title: 'Integrated Railway Management Services',
    description: 'Specialized railway project management including land acquisition, community liaison, regulatory compliance, and coordination for seamless railway infrastructure development.'
  }
];

  const handleReadMore = (serviceId) => {
    // Navigate to services page with service ID
    navigate('/services', { state: { scrollToService: serviceId } });
  };

  return (
    <div className="services-cb-main">
      <div className="services-cb-container">
        <button className="services-cb-button">Our Services</button>
        
        <h1 className="services-cb-heading" data-aos="fade-up">
        Comprehensive Solutions for <br />
        Large-Scale Infrastructure Projects
        </h1>

        <p className="services-cb-subheading" data-aos="fade-up">
          Connecting communities, enterprises, and institutions for sustainable growth.
        </p>

        <div className="services-cb-grid">
          {servicesData.map((service) => (
            <div 
              key={service.id} 
              className="services-cb-card"
              data-aos="fade-up"
              style={{
                backgroundImage: `url(${service.backgroundImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center 70%',
                backgroundRepeat: 'no-repeat'
              }}
            >
              {/* <div className="services-cb-card-overlay"></div> */}
              <div className="services-cb-card-content" >
                <div className="services-cb-icon-wrapper">
                  <img 
                    src={service.icon} 
                    alt={service.title}
                    className="services-cb-icon"
                  />
                </div>
                
                <h3 className="services-cb-card-title">
                  {service.title}
                </h3>
                
                <p className="services-cb-card-description">
                  {service.description}
                </p>
          <button className="cta-btn" onClick={() => handleReadMore(service.id)}>
          Read More
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 8H13M13 8L9 4M13 8L9 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;